<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="280px"
    @keydown.esc="closeJoinDialog"
  >
    <v-card>
      <!-- 공개 회의 -->
      <div
        style="width: 280px; height: 180px;"
        :style="{ display: joinMeetingActive }"
      >
        <div>
          <h3 class="popup-title" style="height: 60px; line-height: 60px;">스마트회의 접속</h3>
          <div class="header-btn" style="margin-right: 30px;"></div>
        </div>
        <div style="display: flex; justify-content: center;">
          <input
            class="form-control"
            type="number"
            placeholder="회의 번호"
            v-model="joinUser.joinNumber"
            style="width: 85%; height: 35px"
          />
        </div>
        <div class="btnArea" style="justify-content: center; margin-top:10px;">
          <button class="noIconButton" @click="closeJoinDialog()">
            닫기
          </button>

          <button class="btnPrimary" @click="meetingJoin()">
            접속
          </button>
        </div>
      </div>

      <!-- 비공개 회의 -->
      <div
        class="dialog-container"
        style="width: 280px; height: 230px;"
        :style="{ display: isPassword }"
      >
        <div>
          <h3 class="popup-title" style="height: 60px; line-height: 60px;">비밀번호 입력</h3>
          <div class="header-btn" style="margin-right: 30px;"></div>
        </div>
        <div style="display: flex; justify-content: center;">
          <input
            type="password"
            style="width: 80%; padding: 10px; margin-top: 30px;margin-bottom: 20px; border-radius: 8px;"
            placeholder="비밀번호를 입력해주세요."
            v-model="password"
          />
        </div>
        <div class="btnArea">
          <button class="noIconButton" @click="closeJoinDialog()">
            닫기
          </button>
          <button class="btnPrimary" @click="checkPw()">
            접속
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';

export default {
  components: {},
  props: ['dialog', 'closeDialog'],
  data () {
    return {
      joinUser: {
        joinName: null,
        joinEmail: null,
        joinNumber: null,
      },
      loading: true,
      joinMeetingActive: '',
      isPassword: 'none',
      password: null,
      isPrivate: false,
      defaultPw: null,
      saehaAuthenticationUrl: null,
      conferenceRoomActive: false,
    };
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    async meetingJoin () {
      if (
        this.joinUser.joinNumber === '' ||
        this.joinUser.joinNumber === null
      ) {
        alert('회의번호 입력 후 접속해주세요');
      }
      let joinNumber = this.joinUser.joinNumber;
      let item = {};
      item['me'] = {
        email: this.$store.state.user.email,
      };
      let userData = {
        email: this.$store.state.user.email,
        meetingKey: joinNumber,
      };
      let meetingInfo = {
        meetingKey: joinNumber,
      };

      let sc = this.encrypt();
      let meetingKey = { meetingKey: this.joinUser.joinNumber, sc: sc };

      this.$http
        .get('/api/auth/getEncodeMeetingKey', {
          params: meetingKey,
        })
        .then((response) => {
          let encodeKey = { meetingKey: response.data };
          // 인코딩 한 키값을 반영

          this.$http
            .get('/api/v1/meetings/checkPw', { params: encodeKey })
            .then((response) => {
              let result = response.data[0];

              let saehaAuthenticationUrl = '/api/auth/joinUrlForSaehaInfo';
              this.conferenceRoomActive = result.conferenceRoomActive;
              if (result.exMeeting === true) {
                // 외부
                if (result.conferenceRoomActive === true) {
                  saehaAuthenticationUrl = '/api/auth/dmzSaehaInfo';
                } else {
                  saehaAuthenticationUrl = '/api/auth/joinUrlForDmzSaehaInfo';
                }
              } else {
                if (result.conferenceRoomActive === true) {
                  saehaAuthenticationUrl = '/api/auth/saehaInfo';
                } else {
                  saehaAuthenticationUrl = '/api/auth/joinUrlForSaehaInfo';
                }
              }

              this.saehaAuthenticationUrl = saehaAuthenticationUrl;
              if (result.isPrivate) {
                this.joinMeetingActive = 'none';
                this.isPassword = '';
                return false;
              }
              this.$http
                .get(saehaAuthenticationUrl, { params: userData })
                .then((response) => {
                  let info = response.data;
                  console.log(info);
                  if (info.meetingInfo.status === 'r') {
                    alert('예약한 시간이 아닙니다.');
                    return false;
                  } else if (info.meetingInfo.status === 'e') {
                    alert('종료된 회의입니다.');
                    return false;
                  }

                  const ds = this.$BodaApp.defaultSettings(info.ds);
                  this.bodaFileLink = info.bodaFileLink;
                  if (info.meetingInfo.conferenceRoomActive === true) {
                    this.$BodaApp.openJoin(
                      {
                        roomCode: info.oj.roomCode
                          ? info.oj.roomCode
                          : info.meetingKey,
                        template: Number(info.oj.template),
                        title: info.meetingInfo.title,
                        userType: 1,
                        userId: info.userData.userId,
                        userName:
                          info.userData.userName + '/' + info.userData.userId,
                        openOption: info.oj.openOption,
                        joinOption: info.oj.joinOption,
                      },
                      () => {
                        console.log('success');
                        this.closeJoinDialog();
                      },
                      (errorCode, reason) => {
                        console.log('## 에러코드 ##');
                        console.log(`errorCode : `, errorCode);
                        console.log(`reason : `, reason);
                        if (
                          errorCode === 'BODA-NOT_INSTALLED' ||
                          errorCode === 'BODA-NOT_CONNECTED_AGENT'
                        ) {
                          this.isLodingShow = '';
                        } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                          if (reason === 'CLIENT_RUNNING') {
                            alert(
                              '영상회 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                            );
                          }
                        }
                      }
                    );
                  } else {
                    // 일반회의
                    this.$BodaApp.openJoin(
                      {
                        roomCode: info.meetingInfo.meetingKey,
                        template: Number(info.oj.template),
                        title: info.meetingInfo.title,
                        userType: info.oj.joinUserType,
                        userId: info.userData.userId,
                        userName: info.userData.userName + `/${info.userData.userId}`,
                        openOption: info.oj.openOption ? info.oj.openOption : '',
                        joinOption: info.oj.joinOption ? info.oj.joinOption : '',
                      },
                      () => {
                        console.log('success');
                        this.closeJoinDialog();
                      },
                      (errorCode, reason) => {
                        console.log('## 에러코드 ##');
                        console.log(`errorCode : `, errorCode);
                        console.log(`reason : `, reason);
                        if (
                          errorCode === 'BODA-NOT_INSTALLED' ||
                          errorCode === 'BODA-NOT_CONNECTED_AGENT'
                        ) {
                          this.isLodingShow = '';
                        } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                          if (reason === 'CLIENT_RUNNING') {
                            alert(
                              '영상회 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                            );
                          }
                        }
                      }
                    );
                  }
                });
            });
        });
    },
    startMeeting () {
      console.log('startMeeting');
      let joinNumber = this.joinUser.joinNumber;
      let item = {};
      item['me'] = {
        email: this.$store.state.user.email,
      };
      let params = {
        meetingKey: joinNumber,
        email: this.$store.state.user.email,
      };

      this.$http
        .get(this.saehaAuthenticationUrl, { params: params })
        .then((response) => {
          let info = response.data;
          console.log(`info : `,info);
          if (info.meetingInfo.status === 'r') {
            alert('예약한 시간이 아닙니다.');
            return false;
          } else if (info.meetingInfo.status === 'e') {
            alert('종료된 회의입니다.');
            return false;
          }

          const ds = this.$BodaApp.defaultSettings(info.ds);
          this.bodaFileLink = info.bodaFileLink;
          if (info.meetingInfo.conferenceRoomActive === true) {
            this.$BodaApp.openJoin(
              {
                roomCode: info.meetingInfo.meetingKey,
                template: Number(info.oj.template),
                title: info.meetingInfo.title,
                userType: info.oj.joinUserType,
                userId: info.userData.userId,
                userName: info.userData.userName + `/${info.userData.userId}`,
                openOption: info.oj.openOption ? info.oj.openOption : '',
                joinOption: info.oj.joinOption ? info.oj.joinOption : '',
              },
              () => {
                console.log('success');
                this.closeJoinDialog();
              },
              (errorCode, reason) => {
                console.log('## 에러코드 ##');
                console.log(`errorCode : `, errorCode);
                console.log(`reason : `, reason);
                if (
                  errorCode === 'BODA-NOT_INSTALLED' ||
                  errorCode === 'BODA-NOT_CONNECTED_AGENT'
                ) {
                  this.isLodingShow = '';
                } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                  if (reason === 'CLIENT_RUNNING') {
                    alert(
                      '영상회 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                    );
                  }
                }
              }
            );
          } else {
            // 일반회의
            this.$BodaApp.openJoin(
              {
                roomCode: info.meetingInfo.meetingKey,
                template: Number(info.oj.template),
                title: info.meetingInfo.title,
                userType: info.oj.joinUserType,
                userId: info.userData.userId,
                userName: info.userData.userName + `/${info.userData.userId}`,
                openOption: info.oj.openOption ? info.oj.openOption : '',
                joinOption: info.oj.joinOption ? info.oj.joinOption : '',
              },
              () => {
                console.log('success');
                this.closeJoinDialog();
              },
              (errorCode, reason) => {
                console.log('## 에러코드 ##');
                console.log(`errorCode : `, errorCode);
                console.log(`reason : `, reason);
                if (
                  errorCode === 'BODA-NOT_INSTALLED' ||
                  errorCode === 'BODA-NOT_CONNECTED_AGENT'
                ) {
                  this.isLodingShow = '';
                } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                  if (reason === 'CLIENT_RUNNING') {
                    alert(
                      '영상회 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                    );
                  }
                }
              }
            );
          }
        });
    },
    async checkPw() {
      let json = {
        meetingKey: this.joinUser.joinNumber,
        checkDecodePw: this.password,
      };
      this.$http
        .post('/api/v1/meetings/checkDecodePw', json)
        .then((response) => {
          if (response) {
            this.startMeeting();
          }
        }).catch(error => {
          if (error) {
            alert('비밀번호를 확인해주세요');
          }
        });
    },
    closePw() {
      this.joinUser.joinNumber = null;
      this.joinMeetingActive = '';
      this.isPassword = 'none';
      this.isPrivate = false;
      this.password = null;
      this.closeDialog();
    },
    closeJoinDialog() {
      this.joinUser.joinNumber = null;
      this.joinMeetingActive = '';
      this.isPassword = 'none';
      this.isPrivate = false;
      this.password = null;
      this.closeDialog();
    },
    encrypt() {
      let secretKey = 'aes256-k-paper-flow!-madrascheck';
      return secretKey;
    },
  },
};
</script>
<style scoped>
.dataTable table td input {
  width: 450px;
}

input::placeholder {
  color: #bfc3c5;
  font-size: 15px !important;
  font-weight: 300 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CitizenParticipationDialog.vue